function wm_updateCartDrawer() {
  document.dispatchEvent(new CustomEvent('cart:build'));
}

function hideUpsellIfInCart() {
  theme.cart.getCart().then(cart => {
    const isAddonInCart = cart.items.some(item => item.handle === 'rollands-chew-toy');
    const addonCard = document.querySelector('.wm-upsell');

    if (isAddonInCart && addonCard) {
      // Fade out animation
      const height = addonCard.offsetHeight;
      addonCard.style.height = `${height}px`;
      requestAnimationFrame(() => {
        addonCard.classList.add('is-fading-out');
      });
      setTimeout(() => addonCard.remove(), 400); // Match CSS timing
    }
  });
}

function wm_handleAddonButtons() {
  document.querySelectorAll('.add-on-manual-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = "Adding...";

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then(() => {
          wm_updateCartDrawer(); // <- calls the real theme-based drawer refresh
        })
        .catch((err) => {
          console.error(err);
          alert('Could not add item to cart.');
        })
        .finally(() => {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  });
}

// Run when DOM is ready
document.addEventListener('DOMContentLoaded', wm_handleAddonButtons);

// Re-run when drawer reopens (Impulse emits this event)
document.addEventListener('drawer:open', function (e) {
  if (e.detail.drawerId === 'CartDrawer') {
    wm_handleAddonButtons();
  }
});

document.addEventListener('cart:build', hideUpsellIfInCart);